import * as React from 'react';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export interface DashButtonProps {
  href: string;
  variant?: 'text' | 'outlined' | 'contained';
  icon: string;
  dataTestId?: string;
  label: string;
  sx?: React.CSSProperties;
  fullWidth?: boolean;
}

const DashButton = ({
  href,
  variant,
  icon,
  dataTestId,
  label,
  fullWidth,
  sx,
}: DashButtonProps): JSX.Element => {
  return (
    <Button
      size="small"
      component={RouterLink}
      variant={variant}
      startIcon={<i className={icon} />}
      data-testid={dataTestId}
      fullWidth={fullWidth}
      to={href}
      sx={{
        ...sx,
        height: '58px',
      }}
    >
      {label}
    </Button>
  );
};

export default DashButton;
